import { z } from 'zod';

/** One background worker process, from its heartbeat row. */
export const workerStatusSchema = z.object({
  workerId: z.string(),
  hostname: z.string(),
  version: z.string(),
  startedAt: z.iso.datetime(),
  lastSeenAt: z.iso.datetime(),
  /** The heartbeat is recent enough for the worker to count as running. */
  healthy: z.boolean(),
});
export type WorkerStatus = z.infer<typeof workerStatusSchema>;

export const workerListResponseSchema = z.object({ items: z.array(workerStatusSchema) });
